import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Heart, ShoppingBag, Star } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useToast } from "../hooks/use-toast";

const ProductCard = ({ product, compact = false }) => {
  const { addItem, toggleWish, inWishlist } = useCart();
  const { toast } = useToast();
  const nav = useNavigate();

  const onAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addItem(product, 1);
    toast({ title: "Added to cart", description: `${product.name} · ${product.weight}` });
  };

  const onWish = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleWish(product);
  };

  const wished = inWishlist(product.id);

  return (
    <div onClick={() => nav(`/product/${product.id}`)} className="ardf-card group relative bg-white rounded-2xl border border-[#efe4c9] overflow-hidden cursor-pointer flex flex-col">
      {/* Badges */}
      <div className="absolute top-3 left-3 z-10 flex flex-col gap-1.5">
        {product.tags?.slice(0, 2).map((t) => (
          <span key={t} className={`text-[10px] font-bold tracking-wider px-2 py-1 rounded-md ${t === "BESTSELLER" ? "bg-brand text-white" : t === "PREMIUM" ? "bg-gold text-[#2a1a15]" : t === "GIFT" ? "bg-olive text-white" : "bg-[#efe4c9] text-[#6b4f39]"}`}>{t}</span>
        ))}
      </div>
      {product.discount > 0 && (
        <span className="absolute top-3 right-3 z-10 bg-[#f3e6c2] text-brand text-[11px] font-bold px-2 py-1 rounded-md">{product.discount}% OFF</span>
      )}

      {/* Wishlist */}
      <button onClick={onWish} aria-label="Wishlist" className="absolute bottom-[42%] right-3 z-10 h-9 w-9 rounded-full bg-white/95 border border-[#efe4c9] flex items-center justify-center text-[#6b4f39] hover:text-brand hover:border-brand transition-colors">
        <Heart className={`h-4 w-4 ${wished ? "fill-brand text-brand" : ""}`} />
      </button>

      {/* Image */}
      <div className="aspect-square bg-[#f9f1de] overflow-hidden">
        <img src={product.image} alt={product.name} loading="lazy" className="ardf-card-img w-full h-full object-cover" />
      </div>

      {/* Body */}
      <div className="p-3.5 md:p-4 flex-1 flex flex-col">
        <div className="flex items-center justify-between mb-1.5">
          <span className="text-[10px] font-bold tracking-[0.15em] text-olive">AGRAWAL RICH</span>
          <span className="flex items-center gap-0.5 text-[11px] text-[#6b4f39]">
            <Star className="h-3 w-3 fill-gold text-gold" /> {product.rating}
          </span>
        </div>
        <h3 className="text-[13.5px] md:text-[14.5px] font-medium text-[#2a1a15] leading-snug line-clamp-2 min-h-[38px]">{product.name}</h3>

        <div className="mt-2 flex items-baseline gap-2">
          <span className="text-[16px] font-bold text-[#2a1a15]">₹{product.price.toLocaleString("en-IN")}</span>
          {product.mrp > product.price && (
            <span className="text-[12px] line-through text-[#a08774]">₹{product.mrp.toLocaleString("en-IN")}</span>
          )}
        </div>
        <div className="text-[11.5px] text-[#6b4f39] mt-0.5">{product.weight}</div>

        <button onClick={onAdd} className="mt-3 w-full h-10 rounded-lg bg-brand text-white text-[13px] font-semibold flex items-center justify-center gap-1.5 hover:bg-[#6c1414] transition-colors">
          <ShoppingBag className="h-4 w-4" /> Add to Cart
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
